import { render, staticRenderFns } from "./QueryResolutionList.vue?vue&type=template&id=b527f68a&scoped=true&"
import script from "./QueryResolutionList.vue?vue&type=script&lang=js&"
export * from "./QueryResolutionList.vue?vue&type=script&lang=js&"
import style0 from "./QueryResolutionList.vue?vue&type=style&index=0&id=b527f68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b527f68a",
  null
  
)

export default component.exports